import React from 'react'
import { Box, Heading, SkeletonText } from '@chakra-ui/react'
import { CardFaqs } from '../cards/CardFaqs'
import { Article } from '../../services/help-center-query.service'
import { HelpRecommendedLoader } from '@/education/shared/components/loaders/HelpRecommendedLoader'

type Height = {
  md: string
  xl: string
}

export type RecomendedListProps = {
  title?: string
  height?: Height
  isLoading?: boolean
  articles?: Article[]
  onClick: (value: string) => void
}

export const RecomendedList = ({
  title = '',
  isLoading = false,
  height,
  articles,
  onClick,
  ...props
}: RecomendedListProps) => {
  const hasData = !isLoading && !!articles?.length

  return (
    <Box
      bg={'#171717'}
      borderRadius={'4px 0 0 4px'}
      paddingY={'42px'}
      paddingX={'35px'}
      textAlign={'start'}
      minWidth={'30%'}
      maxWidth={'30%'}
      minHeight={height}
      {...props}
    >
      <SkeletonText
        isLoaded={!isLoading}
        skeletonHeight={'25px'}
        noOfLines={1}
        width={isLoading ? '70%' : '100%'}
      >
        <Heading
          color={hasData ? 'white' : '#4f4f4f96'}
          textAlign={hasData ? 'start' : 'center'}
          size='md'
          fontSize={'23px'}
          fontWeight={500}
        >
          {hasData ? title : 'No hay artículos recomendados'}
        </Heading>
      </SkeletonText>

      {isLoading && <HelpRecommendedLoader />}
      {hasData &&
        articles.map(article => (
          <CardFaqs
            key={article.id}
            name={article.title}
            body={article.description}
            image={article.urlImage}
            slug={article.slug}
            onClick={onClick}
          />
        ))}
    </Box>
  )
}
